import { request } from "graphql-request";
import { graphql } from "gql/gql";

import { BACKEND_DOMAIN } from "utils/constants";
import {
    buildRequestHeaders,
} from "utils/helpers";

const queryFn = (accessToken: string, carbonReductionMeasureUid: string) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: {
            carbonReductionMeasureUid,
        },
        requestHeaders: buildRequestHeaders(accessToken),
    }).then(
        (data) =>
            data.measure
                .totalEnergyConsumptionCard as MeasureReportTotalEnergyConsumptionCard
    );

const query = graphql(`
    query totalEnergyConsumptionCard($carbonReductionMeasureUid: Uuid!) {
        measure(carbonReductionMeasureUid: $carbonReductionMeasureUid) {
            totalEnergyConsumptionCard {
                totalEnergyConsumptionSavings
                totalEnergyConsumptionSavingsElectricity
                totalEnergyConsumptionSavingsNaturalGas
            }
        }
    }
`);

export default queryFn;
